import { useEffect, useMemo, useRef, useState } from "react";
import { Card } from "../ui/card.jsx";
import { Button } from "../ui/button.jsx";
import { Input } from "../ui/input.jsx";
import { connectSocket, releaseSocket } from "../../lib/socket-client.js";

export default function HighlightsPanel({ roomId, socket: providedSocket }){
  const [highlights, setHighlights] = useState([]);
  const [note, setNote] = useState("");
  const localSocketRef = useRef(null);

  useEffect(() => {
    if (providedSocket) {
      return () => {};
    }
    const sock = connectSocket();
    localSocketRef.current = sock;
    if (roomId) sock.emit("room:join", roomId);
    return () => {
      if (roomId) sock.emit("room:leave", roomId);
      localSocketRef.current = null;
      releaseSocket();
    };
  }, [providedSocket, roomId]);

  useEffect(() => {
    const sock = providedSocket || localSocketRef.current;
    if (!sock) return;
    const onHighlights = (summary) => setHighlights(Array.isArray(summary) ? summary : []);
    sock.on("meeting-highlights", onHighlights);
    return () => { sock.off("meeting-highlights", onHighlights); };
  }, [providedSocket, roomId]);

  const sendNote = () => {
    const text = (note || "").trim();
    if (!text || !roomId) return;
    const sock = providedSocket || localSocketRef.current;
    sock?.emit("meeting:text", { roomId, text });
    setNote("");
  };

  return (
    <Card className="glass-card p-3">
      <div className="glass-header-blue flex items-center justify-between"><b>Meeting Highlights</b><span className="text-xs">{highlights.length}</span></div>
      <ul className="mt-2 space-y-1 text-sm max-h-[200px] overflow-auto pr-1">
        {highlights.map((h, i) => (<li key={i} className="rounded-md border p-2 bg-white/5 dark:bg-slate-900/30">{h}</li>))}
      </ul>
      <div className="mt-2 flex gap-2">
        <Input placeholder="Add a note to highlights…" value={note} onChange={(e)=>setNote(e.target.value)} onKeyDown={(e)=>{ if (e.key === "Enter") sendNote(); }} />
        <Button size="sm" onClick={sendNote}>Add</Button>
      </div>
    </Card>
  );
}
